import type { TFactTrajectoryPoint } from '../../service/model';
import type { TrajectoryService } from '../../service/trajectory-service';

import { isTrajectoryEditableField, type TTrajectoryEditableField } from './editable-fields';
import type { TrajectoryTableValidationStore } from './trajectory-table-validation.store';

const VALIDATED_EDITABLE_FIELDS = new Set<TTrajectoryEditableField>(['md']);

export function applyPointFieldUpdates(
  trajectoryService: TrajectoryService,
  validationStore: TrajectoryTableValidationStore,
  updates: { entityId: string; patch: Partial<TFactTrajectoryPoint> }[],
): void {
  if (updates.length === 0) {
    return;
  }

  const validationErrors = trajectoryService.updateMainPointFields(updates);

  for (const { entityId, patch } of updates) {
    for (const field of Object.keys(patch)) {
      if (!isTrajectoryEditableField(field) || !VALIDATED_EDITABLE_FIELDS.has(field)) {
        continue;
      }

      validationStore.setFieldError(entityId, field, validationErrors.get(entityId) ?? null);
    }
  }
}

export function applyPointFieldUpdate(
  trajectoryService: TrajectoryService,
  validationStore: TrajectoryTableValidationStore,
  entityId: string,
  patch: Partial<TFactTrajectoryPoint>,
): void {
  applyPointFieldUpdates(trajectoryService, validationStore, [{ entityId, patch }]);
}
